import React, { useState } from 'react';
import axios from 'axios';
import ProductionReceipt from '../../app/modules/apps/settings/settting-modules/App setttings/ProductionReceiptModal';
import { useEffect } from 'react';


interface User {
    id: string;
    name: string;
    productionIds: number[];
    registryId: string; // Add this line
    // Add other user properties as needed
}

interface RegistryDocumentProps {
    user: User;
    onClose?: () => void;
    disableModal?: boolean;  // Add this
}


interface RegistryDocumentProps {
    user: User;
    onClose?: () => void;
}

const RegistryDocument: React.FC<RegistryDocumentProps> = ({ user, onClose, disableModal = false }) => {

    const [showModal, setShowModal] = useState<boolean>(false);
    const [receiptData, setReceiptData] = useState<any>(null);
    console.log("user is", user)
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    useEffect(() => {
        console.log('showModal state changed:', showModal);
    }, [showModal]);

    // const handleDownload = async () => {
    //     if (!user.productionIds || !user.productionIds[0]) {
    //         alert('Production ID not found');
    //         return;
    //     }

    //     setIsDownloading(true);
    //     try {
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_BASE_API_URL}productions/${user.productionIds[0]}`,
    //             {
    //                 // ... rest of your headers
    //             }
    //         );

    //         // Handle download logic here
    //         console.log('Download response:', response.data);
    //         setReceiptData(response.data);
    //         setShowModal(true)

    //     } catch (error) {
    //         console.error('Error downloading document:', error);
    //         alert('Error downloading document');
    //     } finally {
    //         setIsDownloading(false);
    //     }
    // };


    const handleDownload = async () => {
        if (!user.productionIds || !user.productionIds[0]) {
            alert('Production ID not found');
            return;
        }

        setIsDownloading(true);

        // Create modal container
        const modalContainer = document.createElement('div');
        modalContainer.id = 'registry-modal';
        modalContainer.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            z-index: 999999;
            display: flex;
            align-items: center;
            justify-content: center;
        `;

        const modalContent = document.createElement('div');
        modalContent.style.cssText = `
            background-color: white;
            padding: 20px;
            border-radius: 8px;
            max-width: 90%;
            max-height: 90%;
            overflow: auto;
            position: relative;
        `;

        // Close button
        const closeButton = document.createElement('button');
        closeButton.innerHTML = '×';
        closeButton.style.cssText = `
            position: absolute;
            top: 10px;
            right: 10px;
            background: none;
            border: none;
            font-size: 20px;
            cursor: pointer;
        `;
        closeButton.onclick = () => modalContainer.remove();

        // Title
        const title = document.createElement('h5');
        title.innerHTML = '';

        // Content container for React component
        const contentDiv = document.createElement('div');
        contentDiv.id = 'receipt-content';
        contentDiv.innerHTML = 'Loading...';

        modalContent.appendChild(closeButton);
        modalContent.appendChild(title);
        modalContent.appendChild(contentDiv);
        modalContainer.appendChild(modalContent);
        document.body.appendChild(modalContainer);

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_API_URL}productions/${user.productionIds[0]}`,
                {
                    // ... rest of your headers
                }
            );

            console.log('Download response:', response.data);
            setReceiptData(response.data);

            // Import createRoot dynamically
            import('react-dom/client').then(({ createRoot }) => {
                const root = createRoot(contentDiv);
                // root.render(React.createElement(ProductionReceipt, { data: response.data }));
                root.render(React.createElement(ProductionReceipt, { data: response.data, user: user }));
            });

        } catch (error) {
            console.error('Error downloading document:', error);
            alert('Error downloading document');
            modalContainer.remove();
        } finally {
            setIsDownloading(false);
        }
    };


    return (
        <>
            <style>
                {`
                .modal-overlay {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    width: 100% !important;
                    height: 100% !important;
                    background-color: rgba(0,0,0,0.5) !important;
                    z-index: 9999 !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                }

                .modal-content {
                    background-color: white !important;
                    padding: 20px !important;
                    border-radius: 8px !important;
                    max-width: 90% !important;
                    max-height: 90% !important;
                    overflow: auto !important;
                    position: relative !important;
                }
            `}
            </style>
            <div className="registry-document-container">
                <div className="mb-4">
                    <h4 className="fw-bold fs-5 mb-3">Registry Document</h4>

                    <div className="fv-row mb-4 d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control form-control-solid me-3"
                            value={`Doc Id - ${user.productionIds[0]}`}
                            readOnly
                            style={{
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #cdcdcd',
                                color: 'black',
                                cursor: 'not-allowed'
                            }}
                        />

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleDownload}
                            disabled={isDownloading}
                            style={{
                                backgroundColor: '#333333',
                                border: 'none',
                                padding: '10px 24px',
                                borderRadius: '8px',
                                fontWeight: '500',
                                minWidth: '120px'
                            }}
                        >
                            {isDownloading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Downloading...
                                </>
                            ) : (
                                'Download'
                            )}
                        </button>
                    </div>
                </div>
            </div>


        </>
    );
};

export default RegistryDocument;